import type { DecisionEngineDestinationUI } from "./definition";

export const accUI: DecisionEngineDestinationUI = {
  campaignSetup: "resource",
  resourceName: "delivery template",
  channelDescription: "Adobe Campaign Classic",
  getReferenceString: (s) => `<%= targetData['${s}'] %>`,
  isInactive: () => false,
  isPreviewSupported: true,
  getTemplateResourceType: ({ type }) => `${type}-template`,
  getResourceType: ({ type }) => `${type}-template`,
  getEmailPreviewMethod: "preview",
  isTestSendSupported: true,
  showIdentifierField: true,
};
